import axios from 'axios';
import { API_ENDPOINTS } from '../../apiConfig';

// ✅ GeneralTaskDTO – flat structure
export interface GeneralTaskDTO {
  id: string;
  tenantId: string;
  tenantName?: string;
  title: string;
  description?: string;
  taskType?: string;
  category?: string;
  parentTaskId?: string;
  taskLevel?: number;
   entityType?: string;
   entityId?: string;
  status?: string;
  priority?: string;
  isBillable?: boolean;
  billed?: boolean;
  estimatedHours?: number;
  actualHours?: number;
  startTime?: string;
  endTime?: string;
  dueDate?: string;
  assignedToId?: string;
  assignedToName?: string;
  createdBy?: string;
  updatedBy?: string;
  isActive?: boolean;
  isDeleted?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

// ✅ GeneralTaskReportDTO – hierarchical/nested with children
export interface GeneralTaskReportDTO {//extends GeneralTaskDTO {
    id: string;
    tenantId: string;
  tenantName?: string;
  title: string;
  description?: string;
  taskType?: string;
  category?: string;
  parentTaskId?: string;
  taskLevel?: number;
  status?: string;
  entityType?: string;
  entityId?: string;
  priority?: string;
  isBillable?: boolean;
  billed?: boolean;
  estimatedHours?: number;
  actualHours?: number;
  startTime?: string;
  endTime?: string;
  dueDate?: string;
  assignedToId?: string;
  assignedToName?: string;
  createdBy?: string;
  updatedBy?: string;
  isActive?: boolean;
  isDeleted?: boolean;
  createdAt?: string;
  updatedAt?: string;
  children: GeneralTaskReportDTO[];
}

// ✅ Generic pagination wrapper
export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

// ✅ Base API path
const API_BASE = `${API_ENDPOINTS.project}/general-tasks`;

export const GeneralTaskApi = {
  // 🔹 Create a general task
  create: (data: GeneralTaskDTO) =>
    axios.post<GeneralTaskDTO>(`${API_BASE}`, data),

  // 🔹 Get a task by ID
  getById: (id: string) =>
    axios.get<GeneralTaskDTO>(`${API_BASE}/${id}`),

  // 🔹 Update a task
  update: (id: string, data: GeneralTaskDTO) =>
    axios.put<GeneralTaskDTO>(`${API_BASE}/${id}`, data),

  // 🔹 Delete a task
  delete: (id: string) =>
    axios.delete<void>(`${API_BASE}/${id}`),

  // 🔹 Search tasks (flat, paginated)
  search: (
    filter: GeneralTaskDTO,
    page: number = 0,
    size: number = 10
  ) =>
    axios.post<PageResponse<GeneralTaskDTO>>(
      `${API_BASE}/search?page=${page}&size=${size}`,
      filter
    ),

  fetchAllGeneralTasks:() => axios.post<PageResponse<GeneralTaskDTO>>(
        `${API_BASE}/search?page=${0}&size=${200}`,
        {}
      ),
  // 🔹 Search with subtasks (nested tree structure)
  searchWithSubtask: (
    filter: GeneralTaskDTO,
    page: number = 0,
    size: number = 100 // you can adjust or disable pagination here
  ) =>
    axios.post<PageResponse<GeneralTaskReportDTO>>(
      `${API_BASE}/v2/search?page=${page}&size=${size}`,
      filter
    ),
};